import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
import VueSignaturePad from "vue-signature-pad";
export default {
  name: 'kw_signature_pad',
  props: {
    value: {
      type: Object,
      default: {}
    },
    nowDataId: {
      default: 0
    },
    filedIndex: {
      type: String,
      default: null
    },
    hidden: {
      type: Boolean,
      default: false
    },
    pageSetInfo: {
      type: Object,
      default: {}
    },
    // 第几条数据
    nowDataIndex: {
      type: String,
      default: ''
    },
    //按钮是否根据角色权限限制
    isLimitButton: {
      type: Boolean,
      default: false
    },
    fieldSetindex: {
      type: Number,
      defaultStatus: 0
    }
  },
  data: function data() {
    return {
      images: [],
      ifLoad: false
    };
  },
  created: function created() {
    var that = this; //

    if (that.value.defaultValStr) {
      // const blob = new Blob([that.value.defaultValStr])
      // const imageUrl = (window.URL || window.webkitURL).createObjectURL(blob)
      // console.log("imageUrl=========",imageUrl);
      // that.images = [imageUrl];
      that.ifLoad = false;
    }
  },
  mounted: function mounted() {
    var that = this;
  },
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},
  watch: {},
  computed: {},
  components: {
    VueSignaturePad: VueSignaturePad
  },
  methods: {
    bindElementChange: function bindElementChange() {
      var that = this;
      that.$emit("bindElementChange", that.value, that.fieldSetindex); // var fieldId = that.value.fieldId;
      // if(typeof(that["zdyValueChange_"+fieldId]) == "function") {
      //   console.log("fieldId=========2222222================",fieldId);
      //     that["zdyValueChange_"+fieldId](that,utils,pageUtils);
      // }
    },
    signatureStart: function signatureStart() {
      this.ifLoad = true;
    },
    // 签字版清除
    signatureUndo: function signatureUndo() {
      var that = this;
      var signaturePad = this.$refs.signaturePad.length ? this.$refs.signaturePad[0] : this.$refs.signaturePad;
      signaturePad.undoSignature();
    },
    //签字版确认
    signatureConfim: function signatureConfim() {
      var that = this;
      var signaturePad = this.$refs.signaturePad.length ? this.$refs.signaturePad[0] : this.$refs.signaturePad;

      var _signaturePad$saveSig = signaturePad.saveSignature(),
          isEmpty = _signaturePad$saveSig.isEmpty,
          data = _signaturePad$saveSig.data;

      that.value.defaultValStr = data;
      that.ifLoad = false; // console.log("isEmpty========",isEmpty);

      console.log("data===========", data);
    }
  }
};